import { render, staticRenderFns } from "./GeozoneCard.vue?vue&type=template&id=34ca5610&"
import script from "./GeozoneCard.vue?vue&type=script&lang=js&"
export * from "./GeozoneCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports